import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const FacebookDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <clipPath id="facebook16-9_svg__clip-path" transform="translate(-2.4)">
        <path fill="none" d="M0 152.66h154.01v116.71H0z" />
      </clipPath>
      <style>
        {
          '.facebook16-9_svg__cls-5{fill:#424242}.facebook16-9_svg__cls-6{fill:#eee}.facebook16-9_svg__cls-7{fill:#9e9e9e}'
        }
      </style>
    </defs>
    <g id="facebook16-9_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="facebook16-9_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          d="M140.68 39.65v-18a14.31 14.31 0 00-14.31-14.32h-14.13v1.92a7.58 7.58 0 01-7.58 7.59H45.54A7.58 7.58 0 0138 9.25V7.33H23A14.31 14.31 0 008.68 21.64v18z"
          transform="translate(-2.4)"
          fill="#1978f2"
        />
        <rect x={28.77} y={23.42} width={89.01} height={11.38} rx={5.69} fill="#0d56b3" />
        <path
          d="M140.64 39.65H8.65v239.59A14.31 14.31 0 0023 293.55h103.34a14.31 14.31 0 0014.31-14.31z"
          transform="translate(-2.4)"
          fill="#fff"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <circle className="facebook16-9_svg__cls-5" cx={18.79} cy={49.79} r={6.62} />
        <path className="facebook16-9_svg__cls-6" d="M29.15 44.96h34.37v3.94H29.15z" />
        <circle className="facebook16-9_svg__cls-7" cx={21.5} cy={141.55} r={3.92} />
        <path className="facebook16-9_svg__cls-6" d="M29.15 139.43h15.28v3.94H29.15z" />
        <circle className="facebook16-9_svg__cls-7" cx={63.09} cy={141.55} r={3.92} />
        <path className="facebook16-9_svg__cls-6" d="M70.74 139.43h15.28v3.94H70.74z" />
        <circle className="facebook16-9_svg__cls-7" cx={101.07} cy={141.55} r={3.92} />
        <path
          className="facebook16-9_svg__cls-6"
          d="M108.72 139.43H124v3.94h-15.28zM29.15 51.05h55.23v4.21H29.15zM6.21 152.58h132.05v4.21H6.21z"
        />
        <path className="facebook16-9_svg__cls-5" d="M6 59.44h132.11v71.88H6z" />
        <circle cx={21.43} cy={275.27} r={4.48} fill="#1878f2" />
        <circle className="facebook16-9_svg__cls-7" cx={54.7} cy={275.27} r={4.48} />
        <circle className="facebook16-9_svg__cls-7" cx={87.96} cy={275.27} r={4.48} />
        <circle className="facebook16-9_svg__cls-7" cx={121.22} cy={275.27} r={4.48} />
        <g clipPath="url(#facebook16-9_svg__clip-path)">
          <circle className="facebook16-9_svg__cls-5" cx={18.86} cy={169.83} r={6.62} />
          <path className="facebook16-9_svg__cls-6" d="M29.22 164.99h34.37v3.94H29.22z" />
          <circle className="facebook16-9_svg__cls-7" cx={21.57} cy={261.59} r={3.92} />
          <path className="facebook16-9_svg__cls-6" d="M29.22 259.46H44.5v3.94H29.22z" />
          <circle className="facebook16-9_svg__cls-7" cx={63.17} cy={261.59} r={3.92} />
          <path className="facebook16-9_svg__cls-6" d="M70.82 259.46H86.1v3.94H70.82z" />
          <circle className="facebook16-9_svg__cls-7" cx={101.14} cy={261.59} r={3.92} />
          <path
            className="facebook16-9_svg__cls-6"
            d="M108.79 259.46h15.28v3.94h-15.28zM29.22 171.08h55.23v4.21H29.22zM6.28 272.61h132.05v4.21H6.28zM6.07 179.48h132.11v71.88H6.07z"
          />
        </g>
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default FacebookDevice169;
